export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/notification/action-types.js